// Allow internationalization features to work across different environments
if (typeof Intl === 'undefined') { window.Intl = require('intl') }

import "@reach/dialog/styles.css"
import 'regenerator-runtime/runtime'
import 'lazysizes'

export * from '@/global/accessible_focus'
export * from '@/global/assets_index'
import { initBackToSearchResults } from '@/global/back_to_search_results'
import { initViewportSampler } from '@/global/perf_observer'
export * from '@/global/skip_to_content'
export * from '@/utils/honeybadger'

import { Turbo } from "@hotwired/turbo-rails"
import ujs from "@rails/ujs"
import ReactOnRails from 'react-on-rails'

import Components from '@/Components'
import AssetPurchasedCard from '@/components/AssetPurchasedCard'
import SearchResult from '@/components/SearchResult'
import SubscriptionAssetPurchasedCard from
  '@/components/SubscriptionAssetPurchasedCard'
import VariantSelectorContainer from '@/components/VariantSelectorContainer'
import VitalSourceEvents from '@/VitalSourceEvents'
const DEPLOYED_ENVIRONMENTS = require('../constants/deployed_environments')
const isDeployedEnvironment = DEPLOYED_ENVIRONMENTS.includes(
  process.env.RAILS_ENV
)

const SERVICE_WORKER = {
  location: '/service-worker.js',
  scope: '/'
}

try {
  initViewportSampler(window, document, screen, Date)
} catch (e) { /* noop */ }

// Wired here (rather than as a module side effect) so tree-shaking with
// package.json "sideEffects": false doesn't drop it from the production build.
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBackToSearchResults)
} else {
  initBackToSearchResults()
}

// Disabling Turbo Drive to prevent unexpected issues with front-end.
// We started using Turbo Frames in small parts of the application,
// but Turbo Drive can cause issues with page transitions, and event handling.
// Disabling until we can test and activate this in a controlled manner.
Turbo.session.drive = false

ujs.start()

function startServiceWorker () {
  if ('serviceWorker' in navigator && isDeployedEnvironment) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register(
        SERVICE_WORKER.location, { scope: SERVICE_WORKER.scope }
      )
    })
  }
}

startServiceWorker()

ReactOnRails.register({
  AssetPurchasedCard,
  Components,
  SearchResult,
  SubscriptionAssetPurchasedCard,
  VariantSelectorContainer,
  VitalSourceEvents
})
